import { render, staticRenderFns } from "./inpatientPayCost.vue?vue&type=template&id=7dc8a614&scoped=true"
import script from "./inpatientPayCost.vue?vue&type=script&lang=js"
export * from "./inpatientPayCost.vue?vue&type=script&lang=js"
import style0 from "./inpatientPayCost.vue?vue&type=style&index=0&id=7dc8a614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8a614",
  null
  
)

export default component.exports